"use client";

import Link from "next/link";
import type { ComponentProps } from "react";
import { trackToolUsed } from "@/lib/analytics/tool-events";
import type { PublicTool } from "@shared/analytics/tools";

type ToolCtaLinkProps = ComponentProps<typeof Link> & {
  tool: PublicTool;
  productTypeSlug?: string;
};

export function ToolCtaLink({
  tool,
  productTypeSlug,
  onClick,
  ...linkProps
}: ToolCtaLinkProps) {
  return (
    <Link
      {...linkProps}
      onClick={(event) => {
        trackToolUsed({ tool, tool_step: "cta_clicked", productTypeSlug });
        onClick?.(event);
      }}
    />
  );
}
